import { render, staticRenderFns } from "./VerticalConfirm.vue?vue&type=template&id=9aba7e2c&"
import script from "./VerticalConfirm.vue?vue&type=script&lang=js&"
export * from "./VerticalConfirm.vue?vue&type=script&lang=js&"
import style0 from "./VerticalConfirm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports